module.exports = __webpack_public_path__ + "img/star-3.ca050866.svg";